import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { GenericObservationDeviceLinkNoData } from 'health/observations/generics';
import { BodyFat } from 'shared/fullColorIcons';
import { roundToDecimals } from 'services/value-formatter';

const typeDefinition = {
  type: ObservationType.BodyFat,
  typeUnitMap: {
    [ObservationType.BodyFat]: Unit.Percent
  },
  unitLabelMap: {
    [Unit.Percent]: local.units.percent
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.bodyFat,
  backPath: { to: routePaths.health },
  centerElement: local.observation.bodyFat.title,
  valueFormatter: (props) => `${roundToDecimals(props.observation.value, 2)}${props.config.unitLabelMap[props.observation.unit]}`,
  noDataText: local.observation.bodyFat.noDataText,
  iconSymbol: BodyFat,
  renderNoDataComponent: (props) => props && <GenericObservationDeviceLinkNoData message={props.config.noDataText} />
};
